/**
 * Boards of the foundation. OWNED BY the foundation (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const authBoards: BoardDef[] = [
  {
    id: "Admin-Login",
    ref: "5",
    title: "Cabinet compta — Connexion",
    area: "auth",
    path: "/connexion",
    href: "/connexion",
    permission: null,
    persona: null,
    kind: "auth",
    nav: null,
    space: null,
    note: "Construit par la fondation (src/auth/login-page.tsx).",
    component: lazy(() => import("./boards/Admin-Login")),
  },
  {
    id: "Admin-Login-Code",
    ref: "5b",
    title: "Cabinet compta — Vérification",
    area: "auth",
    path: "/connexion/code",
    href: "/connexion/code",
    permission: null,
    persona: null,
    kind: "auth",
    nav: null,
    space: null,
    note: "Construit par la fondation ; n'existe qu'avec un code en attente (sinon retour à /connexion).",
    component: lazy(() => import("./boards/Admin-Login-Code")),
  },
];
